<template>
  <a :href="link" :target="target" class="image-link">
    <component :is="icon" />
  </a>
</template>

<script>
import iconPlaceholder from '~/static/assets/icon_placeholder.svg';
import {
  FacebookIcon,
  TwitterIcon,
  PinterestIcon,
  LinkedinIcon,
  TelegramIcon,
} from '~/static/icons';

export default {
  name: 'ImageLink',
  components: {
    FacebookIcon,
    TwitterIcon,
    PinterestIcon,
    LinkedinIcon,
    TelegramIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: false,
      default: '_blank',
    },
    width: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      iconPlaceholder,
    };
  },
};
</script>

<style lang="scss">
.image-link {
  .image-link-img {
    .sf-image {
      outline: none;
    }
    .sf-image--placeholder {
      width: 30%;
      height: auto;
    }
  }
}
</style>
